<template lang="pug">
#drawer-menu-busca-finca
    el-drawer(
        :title='$t("mensagens.menuMapa.area")',
        direction='rtl',
        :class='menuMaior ? "drawer-menu-busca-finca" : "drawer-menu-busca-finca menor"',
        :visible.sync='show',
        :before-close='closeDrawerMenuBuscaFinca',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247'
    )
        template(slot='title', slot-scope='scope')
            div(:class='menuMaior ? "titulo-drawer" : "titulo-drawer-menor"')
                i.mdi.mdi-magnify
                |
                | {{ title }}

        .card-container
            el-menu(
                :default-active='defaultActive',
                :class='menuMaior ? "" : "menu-menor"',
                :collapse='false'
            )
                el-menu-item
                    el-select(
                        v-model='departamento.codigoSelecionado',
                        :loading='departamento.loading',
                        :placeholder='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento")',
                        @change='listarLocalidadeNivelDois',
                        clearable
                    )
                        el-option(
                            v-for='{ label, code } in departamento.lista',
                            :key='code',
                            :label='label',
                            :value='code'
                        )
                el-menu-item
                    el-select(
                        :disabled='!departamento.codigoSelecionado',
                        :loading='distrito.loading',
                        v-model='distrito.codigoSelecionado',
                        :placeholder='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.dist")',
                        clearable
                    )
                        el-option(
                            v-for='{ label, code } in distrito.lista',
                            :key='code',
                            :label='label',
                            :value='code'
                        )
                el-menu-item.flex-buttons
                    el-input(
                        :clearable='true',
                        prefix-icon='el-icon-search',
                        type='text',
                        :placeholder='$t("mensagens.diagnosticoSocioambiental.pesquisaPlaceholderPY")',
                        maxLength='10',
                        style='width: 100%; font-size: 12px',
                        v-model='fincaOuPadron'
                    )
                    el-button(
                        :disabled='!departamento.codigoSelecionado || !distrito.codigoSelecionado || !fincaOuPadron',
                        type='primary',
                        @click='buscarTerritorioPorFincaOrPadron',
                        size='mini',
                        icon='el-icon-plus'
                    )
</template>

<script>
import store from '@/store';
import TerritorioService from '@/services/TerritorioService';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import L from 'leaflet';
import Mapa from '@/utils/mapa/mapa.service';

export default {
    name: 'DrawerMenuBuscaFinca',

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        mapa: {
            type: Object,
            required: true,
            default: () => ({}) // Objeto vazio evita o erro
        }
    },

    data() {
        return {
            title: this.$t('mensagens.menuMapa.pesquisar'),
            defaultActive: '',
            fincaOuPadron: '',
            departamento: {
                codigoSelecionado: null,
                lista: [],
                loading: false
            },
            distrito: {
                codigoSelecionado: null,
                lista: [],
                loading: false
            }
        };
    },

    async mounted() {
        this.listarLocalidadeNivelUm();
    },

    methods: {
        closeDrawerMenuBuscaFinca() {
            this.$emit('closeDrawerMenuBuscaFinca');
        },

        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        },
        async listarLocalidadeNivelUm() {
            this.departamento.loading = true;

            try {
                const { data } =
                    await TerritorioService.buscarDepartamentosParaguay();
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, code: item.codigo };
                    })
                    .sort((a, b) => this.orderName(a, b));

                this.departamento.lista = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            } finally {
                this.departamento.loading = false;
            }
        },

        async listarLocalidadeNivelDois() {
            this.distrito.loading = true;
            this.distrito.codigoSelecionado = null;

            if (!this.departamento.codigoSelecionado) {
                this.distrito.lista = [];
                this.distrito.loading = false;
                return;
            }

            try {
                const { data } =
                    await TerritorioService.buscarDistritosParaguay(
                        this.departamento.codigoSelecionado
                    );
                this.distrito.lista = this.formatarDistritos(data);
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            } finally {
                this.distrito.loading = false;
            }
        },

        formatarDistritos(data) {
            return data
                .map(item => ({
                    label: item.nome,
                    code: item.codigo.replace(/[^\d]/g, '')
                }))
                .sort(this.orderName);
        },

        clearLayers() {
            if (this.geometria) {
                this.mapa.removeLayer(this.geometria);
                this.geometria = null;
                store.dispatch('setCarSelecionadoNaPopup', null);
            }
        },

        mostrarTerritorioNoMapaPY(dadosOutputApi, valorPesquisado) {
            this.clearLayers();

            // Inicializa os limites gerais
            let bounds = L.latLngBounds();

            dadosOutputApi.forEach(geom => {
                const geometriaLayer = Mapa.criarGeoJSON(
                    geom.geometria,
                    mapaEstilos.Geometria.imovelRuralCandidato
                );

                geometriaLayer.identificadorGeometria = valorPesquisado;
                this.mapa.addLayer(geometriaLayer);

                bounds.extend(geometriaLayer.getBounds());
            });

            // Centraliza o mapa para abranger todas as geometrias
            if (bounds.isValid()) {
                this.mapa.fitBounds(bounds, { maxZoom: 14 });
            }
        },

        async buscarTerritorioPorFincaOrPadron() {
            try {
                const response =
                    await TerritorioService.buscarTerritorioPorFincaOrPadron(
                        this.fincaOuPadron,
                        this.departamento.codigoSelecionado,
                        this.distrito.codigoSelecionado
                    );

                // Verificando se a resposta contém o objeto `finca` e se o array `data` está presente
                if (
                    response &&
                    response.data &&
                    response.data.finca &&
                    Array.isArray(response.data.finca.data)
                ) {
                    const data = response.data.finca.data;
                    await this.mostrarTerritorioNoMapaPY(
                        data,
                        this.fincaOuPadron
                    );
                }

                return;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.menuMapa.notificacoes.naoFoiPossivelConsultarCarParaguay'
                    )
                });
            }
        }
    }
};
</script>

<style lang="scss">
#drawer-menu-busca-finca {
    font-family: 'Roboto', 'sans serif';

    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-menu-busca-finca {
        z-index: 500 !important;
        position: absolute;
    }

    .el-drawer__body {
        @include scroll-bar();
    }

    .titulo-drawer {
        font-size: 17px;
        font-weight: 500;
        color: var(--primary);
    }

    .titulo-drawer-menor {
        font-size: 15px;
        font-weight: 500;
        color: var(--primary);
    }

    .text-align-right {
        text-align: right;
    }

    .float-box .float-box-title h2 {
        padding-top: 19px;
        font-size: 16px;
        padding-right: 16px;
        padding-left: 22px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pull-left {
        float: left;
    }

    .el-drawer__header {
        background-color: #e9e9e9;
        padding: 15px !important;
        margin-bottom: 0px;
    }

    .float-box-title {
        width: 100%;
        background-color: #ecf0f1;
    }

    .float-box .float-box-collapse-icon {
        position: absolute;
        right: 15px;
        top: 17px;
        z-index: 10001;
        font-size: 16px;
    }

    .action-icon {
        cursor: pointer;
        color: #777;
    }

    .card-container {
        height: 100%;
        background-color: var(--white);
        overflow-y: auto;
        overflow-x: hidden;

        .el-menu {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;
        }
    }

    .el-menu-item:hover,
    .el-menu-item:focus {
        background-color: unset !important;
    }

    .el-select {
        width: 100% !important;
    }

    .flex-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        button {
            width: 44px;
            height: 39px;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
                margin: 0 !important;
                color: white;
                font-size: 12px !important;
            }
        }
    }
}
</style>
